import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {ErrorMessageResolver} from '../../../modules/core/error/errorMessage.resolver';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class ToastControl {


    constructor(private errorMessageResolver: ErrorMessageResolver,
                private snackBar: MatSnackBar) {}

    presentError(e, message?) {
        if (e) {
            console.dir(e);
        }
        if (!message) {
            message = this.errorMessageResolver.resolveError(e);
        }

        this.presentToast(message, 'error');
    }

    presentConfirmation(message) {
        this.presentToast(message, 'success');
    }

    private presentToast(message, className) {
        this.snackBar.open(message, 'Fermer', {
            duration: 1000 * 10,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: className,
        });
    }


}
